import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const recursoProfissionalRoutes: Routes = [
  {
    path: 'recurso-profissional',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./recurso-profissional.component').then(
            (m) => m.RecursoProfissionalComponent,
          ),
        data: {
          title: 'Interposição de Recurso Profissional',
          roles: [Role.INTERPOSICAO_RECURSO_PROFISSIONAL_CONSULTAR],
          breadcrumb: [{ label: 'Recurso Profissional', url: '/recurso-profissional' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./recurso-profissional-cadastro/recurso-profissional-cadastro.component').then(
            (m) => m.RecursoProfissionalCadastroComponent,
          ),
        data: {
          title: 'Abertura de Interposição de Recurso Profissional',
          roles: [Role.INTERPOSICAO_RECURSO_PROFISSIONAL_CADASTRAR],
          breadcrumb: [
            { label: 'Recurso Profissional', url: '/recurso-profissional' },
            { label: 'Cadastrar', url: '/recurso-profissional/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./recurso-profissional-cadastro/recurso-profissional-cadastro.component').then(
            (m) => m.RecursoProfissionalCadastroComponent,
          ),
        data: {
          title: 'Editar a Abertura de Interposição de Recurso Profissional',
          roles: [Role.INTERPOSICAO_RECURSO_PROFISSIONAL_EDITAR],
          breadcrumb: [
            { label: 'Recurso Profissional', url: '/recurso-profissional' },
            { label: 'Editar', url: '/recurso-profissional/editar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./recurso-profissional-visualizacao/recurso-profissional-visualizacao.component').then(
            (m) => m.RecursoProfissionalVisualizacaoComponent,
          ),
        data: {
          title: 'Detalhe Período de Interposição de Recurso Profissional',
          roles: [Role.INTERPOSICAO_RECURSO_PROFISSIONAL_VISUALIZAR],
          breadcrumb: [
            { label: 'Recurso Profissional', url: '/recurso-profissional' },
            { label: 'Detalhe do Período', url: '/recurso-profissional/visualizar' },
          ],
        },
      },
      {
        path: 'analisar/:id',
        loadComponent: () =>
          import('./recurso-profissional-analise/recurso-profissional-analise.component').then(
            (m) => m.RecursoProfissionalAnaliseComponent,
          ),
        data: {
          title: 'Análise do Recurso Profissional',
          roles: [Role.INTERPOSICAO_RECURSO_PROFISSIONAL_ANALISAR],
          breadcrumb: [
            { label: 'Recurso Profissional', url: '/recurso-profissional' },
            { label: 'Analise', url: '/recurso-profissional/analisar' },
          ],
        },
      },
      {
        path: 'analisar-solicitacao/:id',
        loadComponent: () =>
          import('./recurso-profissional-solicitacao-analise/recurso-profissional-solicitacao-analise.component').then(
            (m) => m.RecursoProfissionalSolicitacaoAnaliseComponent,
          ),
        data: {
          title: 'Análise Interposição de Recurso Profissional',
          roles: [Role.INTERPOSICAO_RECURSO_PROFISSIONAL_ANALISAR],
          breadcrumb: [
            { label: 'Recurso Profissional', url: '/recurso-profissional' },
            { label: 'Análise da Solicitação', url: '/recurso-profissional/analisar-solicitacao' },
          ],
        },
      },
      {
        path: 'visualizar-solicitacao/:id',
        loadComponent: () =>
          import('./recurso-profissional-solicitacao-analise/recurso-profissional-solicitacao-analise.component').then(
            (m) => m.RecursoProfissionalSolicitacaoAnaliseComponent,
          ),
        data: {
          title: 'Detalhe da Solicitação de Recurso Profissional',
          roles: [
            Role.INTERPOSICAO_RECURSO_PROFISSIONAL_VISUALIZAR,
            Role.INTERPOSICAO_RECURSO_PROFISSIONAL_ANALISAR,
          ],
          breadcrumb: [
            { label: 'Recurso Profissional', url: '/recurso-profissional' },
            { label: 'Visualizar Solicitação', url: '/recurso-profissional/visualizar-solicitacao' },
          ],
        },
      },
    ],
  },
];
